function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { GALLERY_CONSTS } from 'pro-gallery-lib';
import Social from './social/Social';
import CollectionsSocial from './social/CollectionsSocial';
import Share from './share/Share';
import EXTERNAL_INFO_TYPE from '../common/constants/externalInfoType';
import TextInfoElement from './TextInfoElement';
import INFO_EVENTS from '../common/constants/infoEvents';

var InfoElement = /*#__PURE__*/function (_TextInfoElement) {
  _inheritsLoose(InfoElement, _TextInfoElement);

  function InfoElement(props) {
    var _this;

    _this = _TextInfoElement.call(this, props) || this;
    _this.state = {
      showShare: false
    };
    _this.shouldShowHoverOnMobile = _this.shouldShowHoverOnMobile.bind(_assertThisInitialized(_this));
    _this.shouldHover = _this.shouldHover.bind(_assertThisInitialized(_this));
    _this.isSmallItem = _this.isSmallItem.bind(_assertThisInitialized(_this));
    _this.isNarrow = _this.isNarrow.bind(_assertThisInitialized(_this));
    _this.isShort = _this.isShort.bind(_assertThisInitialized(_this));
    _this.isVerticalContainer = _this.isVerticalContainer.bind(_assertThisInitialized(_this));
    _this.toggleShare = _this.toggleShare.bind(_assertThisInitialized(_this));
    _this.hasRequiredMediaUrl = _this.hasRequiredMediaUrl.bind(_assertThisInitialized(_this));
    _this.getShare = _this.getShare.bind(_assertThisInitialized(_this));
    _this.getSocial = _this.getSocial.bind(_assertThisInitialized(_this));
    _this.getItemTextsDetails = _this.getItemTextsDetails.bind(_assertThisInitialized(_this));
    _this.createHoverInfoElement = _this.createHoverInfoElement.bind(_assertThisInitialized(_this));
    _this.createCollectionsHoverInfoElement = _this.createCollectionsHoverInfoElement.bind(_assertThisInitialized(_this));
    _this.createAboveBelowRightLeftInfoElement = _this.createAboveBelowRightLeftInfoElement.bind(_assertThisInitialized(_this));
    _this.createSlideshowInfoElement = _this.createSlideshowInfoElement.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = InfoElement.prototype;

  _proto.shouldShowHoverOnMobile = function shouldShowHoverOnMobile() {
    var _this$props = this.props,
        isMobile = _this$props.isMobile,
        viewMode = _this$props.viewMode;

    if (isMobile) {
      var _this$props$options = this.props.options,
          allowDescription = _this$props$options.allowDescription,
          allowTitle = _this$props$options.allowTitle,
          titlePlacement = _this$props$options.titlePlacement,
          hoveringBehaviour = _this$props$options.hoveringBehaviour,
          itemClick = _this$props$options.itemClick,
          alwaysShowHover = _this$props$options.alwaysShowHover,
          previewHover = _this$props$options.previewHover;

      if (hoveringBehaviour === GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW) {
        return false;
      }

      if (itemClick === 'nothing' && this.props.type !== 'video') {
        return true;
      } else if ((allowTitle || allowDescription) && GALLERY_CONSTS.hasHoverPlacement(titlePlacement) && hoveringBehaviour !== GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW) {
        return true;
      }

      if (alwaysShowHover) {
        return true;
      }

      if (viewMode === GALLERY_CONSTS.viewMode.EDIT && previewHover) {
        return true;
      }
    }

    return false;
  };

  _proto.shouldHover = function shouldHover() {
    // see if this could be decided in the preset
    var _this$props2 = this.props,
        options = _this$props2.options,
        viewMode = _this$props2.viewMode,
        isMobile = _this$props2.isMobile;

    if (options.hoveringBehaviour === GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW) {
      return false;
    } else if (options.alwaysShowHover === true) {
      return true;
    } else if (viewMode === GALLERY_CONSTS.viewMode.EDIT && options.previewHover) {
      return true;
    } else if (isMobile) {
      return this.shouldShowHoverOnMobile();
    } else {
      return true;
    }
  };

  _proto.isShort = function isShort() {
    return this.props.style.height < 150;
  };

  _proto.isVerticalContainer = function isVerticalContainer() {
    return this.props.style.width < this.props.style.height + 3;
  };

  _proto.isIconTag = function isIconTag(tagName) {
    return ['button', 'i', 'a', 'svg', 'path'].indexOf(tagName.toLowerCase()) >= 0;
  };

  _proto.itemHasLink = function itemHasLink() {
    var _this$props3 = this.props,
        linkData = _this$props3.linkData,
        linkUrl = _this$props3.linkUrl;
    var itemDoesntHaveLink = (!linkData || linkData.type === undefined) && (linkUrl === undefined || linkUrl === ''); // when itemClick is 'link' but no link was added to this specific item

    return !itemDoesntHaveLink;
  };

  _proto.toggleShare = function toggleShare(event, forceVal) {
    event.stopPropagation();
    event.preventDefault();

    if (event.type === 'mouseout' && (this.isIconTag(event.target.tagName) || event.relatedTarget && this.isIconTag(event.relatedTarget.tagName))) {
      // mouseout event should not be fired if hovering over icons (tag name === I)
      return;
    }

    if (this.props.shouldUseNewSocialSharePopup) {
      this.props.actions.eventsListener(INFO_EVENTS.SOCIAL_SHARE_BUTTON_CLICKED, _objectSpread({
        showSocialSharePopup: true
      }, this.props));
    } else {
      this.setState({
        showShare: typeof forceVal === 'undefined' ? !this.state.showShare : !!forceVal
      });
    }
  };

  _proto.getShare = function getShare() {
    return /*#__PURE__*/React.createElement(Share, _extends({}, this.props, {
      key: "item-share-" + this.props.id,
      showShare: this.state.showShare,
      isVerticalContainer: this.isVerticalContainer(),
      actions: {
        toggleShare: this.toggleShare,
        eventsListener: this.props.eventsListener
      }
    }));
  };

  _proto.getCollectionsSocial = function getCollectionsSocial() {
    return /*#__PURE__*/React.createElement(CollectionsSocial, _extends({}, this.props, {
      showShare: this.state.showShare,
      isSmallItem: this.isSmallItem(),
      isNarrow: this.isNarrow(),
      isShort: this.isShort(),
      isVerticalContainer: this.isVerticalContainer(),
      key: "item-social-" + this.props.id,
      actions: {
        toggleShare: this.toggleShare,
        getShare: this.getShare,
        eventsListener: this.props.eventsListener
      },
      shouldUseNewSocialSharePopup: this.props.shouldUseNewSocialSharePopup
    }));
  };

  _proto.getSocial = function getSocial() {
    return /*#__PURE__*/React.createElement(Social, _extends({}, this.props, {
      showShare: this.state.showShare,
      isSmallItem: this.isSmallItem(),
      isNarrow: this.isNarrow(),
      isShort: this.isShort(),
      isVerticalContainer: this.isVerticalContainer(),
      key: "item-social-" + this.props.id,
      actions: {
        toggleShare: this.toggleShare,
        getShare: this.getShare,
        eventsListener: this.props.eventsListener
      },
      shouldUseNewSocialSharePopup: this.props.shouldUseNewSocialSharePopup
    }));
  };

  _proto.getInfoContainerStyles = function getInfoContainerStyles() {
    var _this$props4 = this.props,
        options = _this$props4.options,
        infoType = _this$props4.infoType;
    var infoStyles = {
      height: '100%',
      width: '100%'
    };

    if (infoType === EXTERNAL_INFO_TYPE.EXTERNAL) {
      var itemHasLink = this.itemHasLink();
      infoStyles = _objectSpread(_objectSpread({}, infoStyles), {}, {
        cursor: options.itemClick === GALLERY_CONSTS.itemClick.NOTHING || options.itemClick === GALLERY_CONSTS.itemClick.LINK && !itemHasLink ? 'default' : 'pointer'
      });
    } else if (infoType === EXTERNAL_INFO_TYPE.SLIDESHOW) {
      infoStyles = _objectSpread(_objectSpread({}, infoStyles), {}, {
        cursor: options.itemClick === GALLERY_CONSTS.itemClick.NOTHING || options.itemClick === GALLERY_CONSTS.itemClick.LINK ? 'default' : 'pointer'
      });
    }

    return infoStyles;
  };

  _proto.createHoverInfoElement = function createHoverInfoElement() {
    var options = this.props.options;
    var social = this.getSocial();
    var share = this.getShare();
    var hoverStyles = {
      height: '100%',
      boxSizing: 'border-box',
      paddingLeft: options.textsHorizontalPadding + 'px',
      paddingRight: options.textsHorizontalPadding + 'px',
      paddingTop: (options.galleryVerticalAlign !== 'center' ? options.textsVerticalPadding : 0) + 'px',
      paddingBottom: (options.galleryVerticalAlign !== 'center' ? options.textsVerticalPadding : 0) + 'px'
    };
    var itemTexts = GALLERY_CONSTS.hasHoverPlacement(options.titlePlacement) && options.hoveringBehaviour !== GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW ? this.getItemTextsDetails() : null; // if titlePlacement (title & description) is BELOW or ABOVE or RIGHT or LEFT, it is not part of the itemHover

    return /*#__PURE__*/React.createElement("div", {
      className: "hover-info-element",
      "data-hook": "hover-info-element",
      style: hoverStyles
    }, itemTexts, social, share);
  };

  _proto.createCollectionsHoverInfoElement = function createCollectionsHoverInfoElement() {
    var social = this.getCollectionsSocial();
    var share = this.getShare();
    var hoverStyles = {
      height: '100%',
      boxSizing: 'border-box',
      padding: '0px'
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "hover-info-element",
      "data-hook": "hover-info-element",
      style: hoverStyles
    }, social, share);
  };

  _proto.createSlideshowInfoElement = function createSlideshowInfoElement() {
    var social = this.getSocial();
    var itemTexts = this.getItemTextsDetails();
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "slideshow-info-element",
      style: {
        height: '100%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "slideshow-info-element-inner"
    }, social, itemTexts));
  };

  _proto.createAboveBelowRightLeftInfoElement = function createAboveBelowRightLeftInfoElement() {
    return this.createTextInfoElement();
  };

  _proto.render = function render() {
    var _this2 = this;

    var infoType = this.props.infoType;
    var infoElement;

    switch (infoType) {
      case EXTERNAL_INFO_TYPE.SLIDESHOW:
        infoElement = this.createSlideshowInfoElement();
        break;

      case EXTERNAL_INFO_TYPE.EXTERNAL:
        infoElement = this.createAboveBelowRightLeftInfoElement();
        break;

      case EXTERNAL_INFO_TYPE.HOVER:
        infoElement = this.createHoverInfoElement();
        break;

      case EXTERNAL_INFO_TYPE.COLLECTIONS_HOVER:
        infoElement = this.createCollectionsHoverInfoElement();
        break;

      default:
        console.warn('InfoElement -> EXTERNAL_INFO_TYPE was not selected');
    }

    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "info-element",
      ref: function ref(e) {
        return _this2.infoContainer = e;
      },
      style: this.getInfoContainerStyles()
    }, infoElement);
  };

  return InfoElement;
}(TextInfoElement);

export { InfoElement as default };